import { ErrorMessage, Field } from "formik";
import React, { PropsWithChildren } from "react";
import { generateClassName } from "../../../hooks/useAttributes";
import IElementProps from "../../../types/ElementProps";
import "./FieldWithLabel.css";

type NativeFieldProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement> & React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "className" | "id" | "name" | "children"
>;

interface IFieldWithLabelProps extends IElementProps, NativeFieldProps {
  label?: string,
  inputClass?: string,
  name: string,
  as?: string,
  bold?: boolean,
  inline?: boolean
}

export default function FieldWithLabel(props: PropsWithChildren<IFieldWithLabelProps>) {

  const { label, inline, readOnly, as, placeholder, className, inputClass, name, bold, children, ...rest } = props;

  const fieldId = `${name}field`;

  const labelClass = generateClassName("form-label m-0", { value: bold, onTrue: "fw-bold" });
  const controlClass = generateClassName(inputClass, "form-control text-field w-100");
  const containerClass = generateClassName(className, "d-flex",
    {
      value: inline,
      standard: "flex-column align-items-start gap-1",
      onTrue: "flex-row align-items-center gap-3"
    });

  return (
    <div className={containerClass}>
      {label && <label htmlFor={fieldId} className={labelClass}>{label}</label>}
      <div className="position-relative w-100">
        <Field
          {...rest}
          as={as}
          disabled={rest.disabled ?? readOnly}
          readOnly={readOnly}
          id={fieldId}
          name={name}
          placeholder={placeholder || label}
          className={controlClass}
        />
        {children}
      </div>
      <ErrorMessage name={name} render={(msg) => <span className="mt-0" style={{ color: "#FF0000" }}>{msg}</span>} />
    </div>
  )
}